import { gql } from '@apollo/client';

export default {
    FETCH_M_LG_CONFIG: gql`
        query FETCH_M_LG_CONFIG($lgcode: String! = "313718") {
            setting_m_lg_config(where: { lgcode: { _eq: $lgcode } }) {
                id
                lgcode
                city_name
                _is_published
                created_year
                is_kessan_confirmed
            }
        }
    `,
};
